import { Box, Button, Grid, TextField, Typography } from '@mui/material';
import React from 'react';
// import { BracesAsterisk, CameraReels, CodeSlash, UiRadiosGrid } from 'react-bootstrap-icons';

function HomeCenContact() {
  return (
    <div>
      <Box>
        <Box>
          <Grid container spacing={2} style={{ padding: '1px 1px 1px 40px' }}>
            <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-start' }}>
              <Typography variant='h4' sx={{ fontFamily: 'Roboto, Arial, sans-serif', fontWeight: 'bold', marginLeft: '6px' }}>
                Contact Me
              </Typography>
            </Grid>
            <Grid item xs={12} style={{ textAlign: 'left',marginBottom:'50px',marginTop:'10px' }}>
              <Box style={{width:'90%',background:'#EEEEEE',padding:'40px 60px',borderRadius:'5px'}}>
                <Typography sx={{ fontFamily: 'Wittgenstein, serif', fontSize: '16px', lineHeight: '1.5' ,marginLeft:'-5px',fontWeight: 'bold' }}>
                  Dont be shy to contact me
                </Typography>
                 <Grid container spacing={2} style={{marginTop:'20px'}}>
                     <Grid item xs={12}>
                     <TextField id="standard-basic" label="Name" variant="standard" style={{width:'100%'}}/>
                     </Grid>
                     <Grid item xs={12} style={{marginTop:'20px'}}>
                     <TextField id="standard-basic" label="Email" variant="standard" style={{width:'100%'}}/>
                     </Grid>
                     <Grid item xs={12} style={{marginTop:'20px'}}>
                     <TextField id="standard-basic" label="Message" variant="standard" style={{width:'100%'}}/>
                     </Grid>
                     <Grid item xs={12} style={{marginTop:'35px'}}>
                     <Button variant="outlined" size="large" style={{outline:'black'}}>
                        Submit
                      </Button>
                     </Grid>
                     
                 </Grid>
              </Box>
              
            </Grid>
          </Grid>
        </Box>

      </Box>
    </div>
  )
}

export default HomeCenContact;
